import Sidebar from '../modules/Sidebar';

export default {
    init() {
        Sidebar();
    },
    finalize() {

    },
};



// WEBPACK FOOTER //
// ./assets/src/js/routes/category.js